










export default {
  name: 'Footer',
  props: {
    slotComponent: {},
    slotProps: {},
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppModal/components/Footer.vue